import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import AccountExpiredModal from '../components/AccountExpiredModal';

class AccountExpired extends PureComponent {
  render() {
    const {
      displayModal,
      location: { pathname },
    } = this.props;
    const show = displayModal && !pathname.startsWith('/billing');

    return (
      <AccountExpiredModal
        show={show}
      />
    );
  }
}

const mapStateToProps = ({ user }) => {
  const wasSubscribed = user.get('was_subscribed');
  const wasTrial = user.get('was_trial');
  const isSaucePlanExpired = user.hasReadOnlyAccess() && (wasSubscribed || wasTrial);
  const isTestObjectPlanFree = !user.hasTestObjectPlan();

  return ({
    displayModal: isSaucePlanExpired && isTestObjectPlanFree,
  });
};

AccountExpired.propTypes = {
  displayModal: PropTypes.bool.isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string,
  }).isRequired,
};

export default withRouter(connect(mapStateToProps)(AccountExpired));
export {
  AccountExpired,
  mapStateToProps,
};
